import {JsonProperty} from "json-object-mapper";
import {EMPTY, noop, Observable, of} from "rxjs";

import {AllowAll} from "@app/shared/filters/allow-all.model";

export class FilterConfiguration {
  @JsonProperty({type: AllowAll}) public allowAll?: AllowAll;
  @JsonProperty() public defaultValue?: string | number;
  @JsonProperty() public transform?: (options: Observable<any>) => Observable<any>;
  @JsonProperty() public storageHandler?: (value: any) => void;
  @JsonProperty() public update?: (value: any) => void;
  @JsonProperty() public disabled?: () => Observable<any>;
  @JsonProperty() public disabledLabel?: string;
  @JsonProperty() public isStudentOrGuide?: boolean;
  @JsonProperty() public showAllSubjects?: boolean;

  constructor() {
    this.allowAll         = new AllowAll();
    this.defaultValue     = null;
    this.transform        = null;
    this.storageHandler   = noop;
    this.update           = () => EMPTY;
    this.disabled         = () => of(false);
    this.disabledLabel    = null;
    this.isStudentOrGuide = null;
    this.showAllSubjects = false;
  }
}
